<template>
  <v-dialog
    v-model="model"
    transition="dialog-bottom-transition"
    :max-width="maxWidth"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
      >{{ title }}
      </v-toolbar>
      <v-card-text class="mt-5">
        <v-row>
          <v-text-field
            label="Имя ребёнка"
            v-model="profile.name"
            :error-messages="errorsName"
            :error="errorsName.length > 0"
            @change="checkFields(profile, ['name'])"
            @blur="checkFields(profile, ['name'])"
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiAccountChild }}</v-icon>
            </template>
          </v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            type="date"
            label="Дата рождения"
            hint="Графики строятся для детей от двух лет"
            :max="currentDateMinus2Year"
            v-model="profile.birthdate"
            :error-messages="errorsBirthdate"
            :error="errorsBirthdate.length > 0"
            @change="checkFields(profile, ['birthdate'])"
            @blur="checkFields(profile, ['birthdate'])"
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiCalendar }}</v-icon>
            </template>
          </v-text-field>
        </v-row>
        <v-row>
          <v-select
            label="Пол"
            :items="[
                {text: 'Мужской', value: 'male'},
                {text: 'Женский', value: 'female'},
              ]"
            v-model="profile.sex"
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiGenderMaleFemale }}</v-icon>
            </template>
          </v-select>
        </v-row>

        <v-row>
          <v-select
            label="Уровень ДЦП по шкале GMFCS"
            :items="levelItems"
            v-model="profile.disability"
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiHumanCane }}</v-icon>
            </template>
          </v-select>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          @click="saveProfile(profile)"
        >Сохранить
        </v-btn>
        <v-btn
          text
          @click="$emit('close')"
        >Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiAccountChild,
  mdiCalendar,
  mdiFaceManProfile,
  mdiFaceWomanProfile,
  mdiGenderMaleFemale,
  mdiHumanCane,
  mdiPlus,
  mdiTrashCan
} from '@mdi/js'

import config from '@/app/config'
import profileDB from '@/app/profile'
import utils from '@/app/utils'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object,
      default: function () {
        return {
          name: '',
          birthdate: '',
          sex: profileDB.SEX_MALE,
          disability: 1
        }
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      mdiPlus,
      mdiCalendar,
      mdiAccountChild,
      mdiGenderMaleFemale,
      mdiFaceManProfile,
      mdiFaceWomanProfile,
      mdiTrashCan,
      mdiHumanCane,
      errorsName: [],
      errorsBirthdate: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    currentDateMinus2Year () {
      let date = new Date()
      date.setFullYear(date.getFullYear() - 2)
      return utils.getDateYmd(date)
    },
    maxWidth () {
      return config.maxWidth
    },
    levelItems () {
      let items = []
      for (let i = 1; i <= 6; i++) {
        items.push({ text: profileDB.levelName(i), value: i })
      }
      return items
    }
  },
  methods: {
    saveProfile (profile) {
      this.checkFields(profile)
      if (!this.errorsName.length && !this.errorsBirthdate.length) {
        profileDB.save(profile).then(profileId => {
          if (!profile.id) {
            profile.id = profileId
          }
          this.$emit('save', profile)
        })
      }
    },
    deleteProfile (profile) {
      if (confirm('Вы действительно хотите удалить профиль ' + (profile.name || 'Без имени') +
        (profile.birthdate ? ' (' + profile.birthdate + ')' : ''))) {
        profileDB.remove(profile.id).then(() => {
          this.$emit('remove', profile)
        })
      }
    },
    checkFields (profile, fields = []) {
      if ((!fields.length || fields.indexOf('name') >= 0)) {
        this.errorsName = []
        if (!profile.name) {
          this.errorsName.push('Не задано имя')
        }
      }
      if ((!fields.length || fields.indexOf('birthdate') >= 0)) {
        this.errorsBirthdate = []
        if (!profile.birthdate) {
          this.errorsBirthdate.push('Не задана дата рождения')
        } else if (new Date(profile.birthdate) > new Date(this.currentDateMinus2Year)) {
          this.errorsBirthdate.push('Ребёнок должен быть старше двух лет')
        }
      }
    }
  }
}
</script>
